module.exports = __webpack_public_path__ + "static/media/0081_Medium.2ac17ffc.jpg";